<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system/index';
	import EventLog from 'src/components/EventLog/EventLog.svelte';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
	export let openedEventTimestamp: number | null = null;
</script>

<SidepanelContent>
	<EventLog {device} type={'device'} {openedEventTimestamp} />
</SidepanelContent>
